import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import Badge from "@mui/material/Badge";

import {LookCartIcon} from "../../common/icons";
import {
  setLookActiveCategory,
  setLookOpened,
  setLookPageOpened
} from "../../../actions/lookFunctions";
import {ROUTES} from "../../../routes";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import LookCanvasContext from "../lookCanvasContext";
import {zoomCanvasOut} from "./lookFunctions";
import {setCanvasScale} from "../../../actions/actionFunctions";
import {getCartItemsCount} from "../grohe/groheNavigation/groheFunctions";
import {isIframe} from "../../../misc/helpers";


const LookCartButton = (props) => {

  const {intl, lookOpened, setLookOpened, setLookPageOpened, lookActiveCategory, fabricatorData, className,
    setLookActiveCategory, setCanvasScale, cartItems, history, isPhoneNumberValidated} = props;
  const fabricatorSettings = fabricatorData.settings;

  const isLixil = isIframe() && fabricatorData.isLixil;
  if (isLixil || !fabricatorSettings.checkout) {
    return null
  }

  const cartButtonClick = (imageCanvas) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookCartButton);
    if (lookOpened) {
      setLookOpened(false);
    }
    if (lookActiveCategory) {
      setLookActiveCategory("");
    }
    if (fabricatorSettings.enableQuote && !isPhoneNumberValidated) {
      setLookPageOpened(ROUTES.list);
      history.push(ROUTES.list);
    } else {
      setLookPageOpened(ROUTES.cart);
      history.push(ROUTES.cart);
    }
    zoomCanvasOut(imageCanvas, setCanvasScale);
  };

  const cartItemsLength = getCartItemsCount(cartItems, intl);

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <div className={"look-cart-button" + (className ? " " + className : "")}>
          <Badge badgeContent={cartItemsLength}
                 color="primary"
                 invisible={!cartItemsLength}>
            <IconButton aria-label={intl.formatMessage({id:"iconButton.cart"})}
                        className="look-icon look-icon--white2 look-icon--with-shadow"
                        onClick={() => cartButtonClick(imageCanvas)}>
              <SvgIcon>
                <LookCartIcon />
              </SvgIcon>
            </IconButton>
          </Badge>
          {/*<span className="grohe-sidebar__header-button-text"*/}
          {/*      onClick={() => cartButtonClick(imageCanvas)}>*/}
          {/*  <FormattedMessage id="grohe.header.cart"/>*/}
          {/*</span>*/}
        </div>
      )}
    </LookCanvasContext.Consumer>
  )
};

LookCartButton.propTypes = {
  className: PropTypes.string,
}

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  const {lookPageOpened, lookActiveCategory, lookOpened} = store.lookState;
  const {cartItems} = store.cartState;
  const {isPhoneNumberValidated} = store.userState;

  return {
    lookPageOpened,
    lookActiveCategory,
    lookOpened,
    cartItems,
    fabricatorData,
    isPhoneNumberValidated,
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setLookPageOpened,
  setLookActiveCategory,
  setCanvasScale,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookCartButton)
  )
)
